import React from 'react';
import { CheckboxInput, AddressSection } from './FormComponents';

const BusinessAddress = ({ handleBlur,formData,errorData, handleChange }) => (
 <div className="card mb-2"  style={{ borderRadius: 0,paddingTop:'0px' }}>
<div className="" style={{padding: "8px 15px 0px 11px"}}>
      {/* <CheckboxInput
        label="Same as Registered Address"
        name="sameAsRegistered"
        checked={formData.sameAsRegistered}
        onChange={handleChange}
      /> */}
        <AddressSection 
          prefix="business" 
          formData={formData} 
          handleChange={handleChange} 
          required 
          errorData={errorData}
        handleBlur={handleBlur}
        />
    </div>
    </div>
);

export default BusinessAddress;